var _filter, _rect, _rect2, _text, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgSingleThread(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 480",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0f0f1a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a1a2e"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodeGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#22c55e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#16a34a"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "activeCore",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4338ca"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "idleCore",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1e1e3a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#15152a"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 750,
    height: 480,
    rx: 16,
    fill: "url(#bg3)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 750,
    height: 480,
    rx: 16,
    fill: "none",
    stroke: "#22c55e",
    strokeWidth: 1,
    opacity: 0.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 38,
    textAnchor: "middle",
    fill: "#86efac",
    fontSize: 20,
    fontWeight: 700,
    opacity: 0
  }, "\n    Node.js Single-Threaded Model\n    ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    fill: "freeze"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    begin: "0.3s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 55,
    width: 450,
    height: 120,
    rx: 14,
    fill: "#0d1f0d",
    stroke: "#22c55e",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 55,
    width: 450,
    height: 35,
    rx: 14,
    fill: "url(#nodeGrad)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 76,
    width: 450,
    height: 14,
    fill: "url(#nodeGrad)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 78,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 14,
    fontWeight: 700
  }, "\u2B22 Node.js Process"), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 105,
    width: 370,
    height: 50,
    rx: 10,
    fill: "#1a2e1a",
    stroke: "#4ade80",
    strokeWidth: 1.5,
    strokeDasharray: "4,2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 12,
    to: 0,
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 127,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 13,
    fontWeight: 600
  }, "\uD83D\uDD04 Main Thread (Event Loop)"), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 146,
    textAnchor: "middle",
    fill: "#86efac",
    fontSize: 11
  }, "Handles ALL incoming requests \u2014 single-threaded"), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 130,
    r: 5,
    fill: "#22c55e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;6;3",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.3;1",
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.4s",
    begin: "0.8s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375,
    y1: 175,
    x2: 375,
    y2: 210,
    stroke: "#4ade80",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370,207 375,217 380,207",
    fill: "#4ade80"
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 197,
    fill: "#94a3b8",
    fontSize: 11
  }, "runs on"), /*#__PURE__*/React.createElement("circle", {
    cx: 375,
    cy: 185,
    r: 3,
    fill: "#4ade80",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    from: 178,
    to: 212,
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0.9,
    to: 0,
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.8s",
    begin: "1s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 235,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 13,
    fontWeight: 600
  }, "16 CPU Cores"), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 250,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 273,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 0"), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 293,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 250,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 273,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 1"), /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 293,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 250,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 265,
    y: 273,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 2"), /*#__PURE__*/React.createElement("text", {
    x: 265,
    y: 293,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 250,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 273,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 3"), /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 293,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 250,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 425,
    y: 273,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 4"), /*#__PURE__*/React.createElement("text", {
    x: 425,
    y: 293,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 250,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 273,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 5"), /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 293,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 250,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#activeCore)",
    stroke: "#6c63ff",
    strokeWidth: 2,
    filter: "url(#glow3)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.8;1;0.8",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    x: 585,
    y: 273,
    textAnchor: "middle",
    fill: "#fff",
    fontSize: 10,
    fontWeight: 700
  }, "Core 6"), /*#__PURE__*/React.createElement("text", {
    x: 585,
    y: 293,
    textAnchor: "middle",
    fill: "#a5f3fc",
    fontSize: 9,
    fontWeight: 600
  }, "77% \u26A1"), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 250,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 665,
    y: 273,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 7"), /*#__PURE__*/React.createElement("text", {
    x: 665,
    y: 293,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 315,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 338,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 8"), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 358,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 315,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 338,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 9"), /*#__PURE__*/React.createElement("text", {
    x: 185,
    y: 358,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 315,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 265,
    y: 338,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 10"), /*#__PURE__*/React.createElement("text", {
    x: 265,
    y: 358,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 315,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 338,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 11"), /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 358,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 315,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 425,
    y: 338,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 12"), /*#__PURE__*/React.createElement("text", {
    x: 425,
    y: 358,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 315,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 338,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 13"), /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 358,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 550,
    y: 315,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 585,
    y: 338,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 14"), /*#__PURE__*/React.createElement("text", {
    x: 585,
    y: 358,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 315,
    width: 70,
    height: 55,
    rx: 8,
    fill: "url(#idleCore)",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 665,
    y: 338,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 10,
    fontWeight: 600
  }, "Core 15"), /*#__PURE__*/React.createElement("text", {
    x: 665,
    y: 358,
    textAnchor: "middle",
    fill: "#ef4444",
    fontSize: 9
  }, "IDLE"), /*#__PURE__*/React.createElement("path", {
    d: "M375,217 L375,230 L585,230 L585,250",
    fill: "none",
    stroke: "#4ade80",
    strokeWidth: 2,
    strokeDasharray: "5,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 16,
    to: 0,
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0,
    to: 1,
    dur: "0.6s",
    begin: "1.5s",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 390,
    width: 610,
    height: 70,
    rx: 12,
    fill: "#1a0a0a",
    stroke: "#ef4444",
    strokeWidth: 1.5,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 417,
    textAnchor: "middle",
    fill: "#fca5a5",
    fontSize: 14,
    fontWeight: 700
  }, "\n      \u26A0\uFE0F  Only 1 out of 16 cores is being used  \u2192  ~6% CPU utilization\n    "), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 440,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 12
  }, "\n      87% of computing resources are completely wasted!\n    "), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    y: 415,
    r: 4,
    fill: "#ef4444"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "1.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 630,
    y: 415,
    r: 4,
    fill: "#ef4444"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.2;1",
    dur: "1.2s",
    begin: "0.6s",
    repeatCount: "indefinite"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgSingleThread);
export default __webpack_public_path__ + "static/media/svg-single-thread.b79c5ba7d55fc3f0012ecc15d740f252.svg";
export { ForwardRef as ReactComponent };